var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownload(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.833 17.484a5.417 5.417 0 01-2.446-10 6.668 6.668 0 0113.226 0 5.417 5.417 0 01-2.446 10v.016H5.833v-.016zm5-7.484V6.667H9.167V10h-2.5L10 14.167 13.333 10h-2.5z",
    fill: "#fff"
  })));
}
export default __webpack_public_path__ + "static/images/download-banner/download.svg";
export { SvgDownload as ReactComponent };